import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { getEnrollmentFilters, getEnrollmentSchedule, getObjectTypeId } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { isEventBasedWorkflow, hasEventEnrollmentTriggers } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
import EventFilterView from 'automation-ui-enrollment/components/eventEnrollment/EventFilterView';
import EventRefinementView from 'automation-ui-enrollment/components/eventEnrollment/EventRefinementView';
import EnrollmentFilterViewer from 'automation-ui-enrollment/components/filters/EnrollmentFilterViewer';
import TriggerGroupContainer from 'automation-ui-enrollment/components/common/TriggerGroupContainer';
import ScheduledEnrollmentDetailsGroup from 'automation-ui-enrollment/components/scheduledEnrollment/ScheduledEnrollmentDetailsGroup';
import DatasetEnrollmentCardContent from 'automation-ui-canvas/components/enrollment/DatasetEnrollmentCardContent';
import { Text } from 'foundations-components/components/Text';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledEmptyTile = styled.div.withConfig({
  displayName: "EnrollmentCardContent__StyledEmptyTile",
  componentId: "jeedlo-0"
})(({
  disabled,
  theme: _theme
}) => {
  const theme = _theme;
  return {
    backgroundColor: disabled ? theme.color['fill-tertiary-default'] : theme.color['fill-transparent-default'],
    color: disabled ? theme.color['text-core-subtle'] : theme.color['text-interactive-default'],
    fontWeight: disabled ? '400' : '500',
    border: `1px solid ${disabled ? theme.color['text-primary-disabled'] : theme.color['border-interactive-default']}`,
    borderRadius: theme.borderRadius['100'],
    padding: `${theme.space['200']} ${theme.space['300']}`
  };
});
const EnrollmentCardContent = ({
  flow,
  filtersFromTemplate,
  readOnly
}) => {
  const filters = getEnrollmentFilters(flow);
  const flowObjectTypeId = getObjectTypeId(flow);
  const enrollmentTrigger = flow.enrollmentTrigger;
  const enrollmentSchedule = getEnrollmentSchedule(flow);
  const enrollmentCriteria = flow.enrollmentCriteria;
  const showEventEnrollment = isEventBasedWorkflow(flow.toHybridFlowInterface()) && hasEventEnrollmentTriggers(flow.toHybridFlowInterface());
  const showListEnrollment = enrollmentTrigger === 'LIST' || flow.associatedLists.some(list => list.listTypes.includes('ENROLLMENT_LIST'));
  const isObjectlessWorkflow = getIsObjectlessFlow(flow.toHybridFlowInterface());
  const value = filters || filtersFromTemplate;
  const eventRefinementCriteria = !enrollmentCriteria || enrollmentCriteria.triggerType !== 'EVENT' ? undefined : enrollmentCriteria.refinementCriteria;
  let triggerCriteriaView = /*#__PURE__*/_jsx(TriggerGroupContainer, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrollment.canvas.manualEnrollmentGroupHeading"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrollment.canvas.manualEnrollmentTrigger"
    })
  });
  let refinementCriteriaView = null;
  const emptyCriteriaView = /*#__PURE__*/_jsx(StyledEmptyTile, {
    disabled: readOnly,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: readOnly ? 'enrollment.canvas.emptyRefinementCriteriaMessage' : 'enrollment.canvas.chooseRefinementCriteriaMessage'
    })
  });
  if (showEventEnrollment) {
    triggerCriteriaView = /*#__PURE__*/_jsx(EventFilterView, {
      flowObjectTypeId: flowObjectTypeId,
      triggers: flow.getTriggers()
    });
    if (eventRefinementCriteria) {
      refinementCriteriaView = /*#__PURE__*/_jsx(EventRefinementView, {
        flow: flow.toHybridFlowInterface()
      });
    } else {
      refinementCriteriaView = emptyCriteriaView;
    }
  }
  if (showListEnrollment) {
    triggerCriteriaView = null;
    refinementCriteriaView = /*#__PURE__*/_jsx(EnrollmentFilterViewer, {
      objectTypeId: flowObjectTypeId,
      emptyFilterMessage: emptyCriteriaView,
      value: value
    });
  }
  if (enrollmentSchedule) {
    triggerCriteriaView = /*#__PURE__*/_jsx(ScheduledEnrollmentDetailsGroup, {
      enrollmentSchedule: enrollmentSchedule,
      objectTypeId: flowObjectTypeId
    });
    const showDatasetEnrollment = (enrollmentCriteria === null || enrollmentCriteria === void 0 ? void 0 : enrollmentCriteria.triggerType) === 'DATASET';
    if (showDatasetEnrollment) {
      refinementCriteriaView = /*#__PURE__*/_jsx(DatasetEnrollmentCardContent, {
        datasetId: enrollmentCriteria.datasetId,
        objectTypeId: flowObjectTypeId
      });
    }
  }
  if (enrollmentTrigger === null) {
    triggerCriteriaView = /*#__PURE__*/_jsx(StyledEmptyTile, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrollment.canvas.configuringTriggerMessage"
      })
    });
    refinementCriteriaView = null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [triggerCriteriaView && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h6",
        typography: "heading-25",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrollment.canvas.triggerCriteriaHeading"
        })
      }), triggerCriteriaView]
    }), refinementCriteriaView && !isObjectlessWorkflow && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, Object.assign({
        as: "h6",
        typography: "heading-25"
      }, triggerCriteriaView ? {
        marginBlockStart: '400',
        marginBlockEnd: '200'
      } : {
        marginBlockEnd: '200'
      }, {
        children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "enrollment.canvas.refinementCriteriaHeading_cob",
          objectTypeId: flowObjectTypeId
        })
      })), refinementCriteriaView]
    })]
  });
};
export default EnrollmentCardContent;